import { Injectable } from "@angular/core";
import { Field } from "@shared/field.model";
import { Validators } from "@angular/forms";
import { ChoicesField } from "@shared/field-choices";

@Injectable({
  providedIn: "root",
})
export class RangeAgesFieldService {
  getFields() {
    let fields: Field<any>[] = [
      new ChoicesField({
        key: "rangeAge",
        id: "rangeAge",
        classes: "options-dialog",
        value: "",
        options: [
          {
            key: "18 - 40",
            value: "18 - 40 años",
          },
          {
            key: "41 - 55",
            value: "41 - 55 años",
          },
          {
            key: "56 - 65",
            value: "56 - 65 años",
          },
          {
            key: "66 - *",
            value: "Mayor a 66 años",
          },
        ],
        required: true,
        validations: [Validators.required],
        errorMessages: [
          {
            rule: "required",
            message: "Escoje el rango de edad",
          },
        ],
        order: 1,
      }),
    ];
    return fields.sort((a, b) => a.order - b.order);
  }
}
